import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { PageNotFound } from '@openx/components-core/lib/PageNotFound/PageNotFound';
import { AdInventoryAndPricingSection } from '@openx/components-direct-deals/lib/PublisherDetails/sections/AdInventoryAndPricingSection';
import { AudienceAndReachSection } from '@openx/components-direct-deals/lib/PublisherDetails/sections/AudienceAndReachSection';
import { DirectDealsDetailsHeader } from '@openx/components-direct-deals/lib/PublisherDetails/sections/DirectDealsDetailsHeader';
import { MoreInfoSection } from '@openx/components-direct-deals/lib/PublisherDetails/sections/MoreInfoSection';
import { useDirectDealsContext } from '@openx/components-direct-deals/lib/utils/context/DirectDealsContext';
import { DirectDealsPublisherDetailsContext } from '@openx/components-direct-deals/lib/utils/context/DirectDealsPublisherDetailsContext';
import { RequestDirectDealModalProvider } from '@openx/components-direct-deals/lib/utils/context/RequestDirectDealModalContext';
import { PageHeader } from '@openx/components-header/PageHeader';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { listSearchParams } from '../../utils/useListCriteria';

export const DirectDealsDetailsPage = () => {
  const navigate = useNavigate();
  const { publisherId } = useParams<{ publisherId: string }>();
  const { t } = useTranslation();
  const { useDirectDealsDetailsFetch } = useDirectDealsContext();
  const { data, loading, error } = useDirectDealsDetailsFetch(publisherId || '');

  const onGoBack = () => {
    navigate(`..?${listSearchParams.directDeals ?? ''}`);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (!data || error) {
    return <PageNotFound />;
  }

  const pageTitle = `${t('Details:')} ${data.name}`;

  return (
    <PageHeader titlePrefix="OpenXSelect" title={pageTitle} goBack={onGoBack}>
      <RequestDirectDealModalProvider>
        <DirectDealsPublisherDetailsContext.Provider value={{ details: data }}>
          <DirectDealsDetailsHeader />

          <AudienceAndReachSection />

          <AdInventoryAndPricingSection />

          <MoreInfoSection />
        </DirectDealsPublisherDetailsContext.Provider>
      </RequestDirectDealModalProvider>
    </PageHeader>
  );
};
